
import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../_services/auth_service';
import { RedirectService } from '../_services/redirect_service';
import {HttpResponse} from "@angular/common/http";
import {of} from "rxjs";
import {catchError, map} from "rxjs/operators";
import {environment} from "../../environments/environment";

export const AuthGuard: CanActivateFn = (route, state) => {
    const authService = inject(AuthService);
    const router = inject(Router);
    const redirect = inject(RedirectService);

    return authService.getUserData().pipe(
        map((response: HttpResponse<any>) => {
            // Controlla se l'utente ha un ruolo
            const isAuth = response.body?.ruolo != '';
            return isAuth;
        }),
        catchError((error) => {
            // In caso di errore, impedisci la navigazione
            if (!environment.production) {
                console.error('Errore durante la verifica', error);
            }
            redirect.save(state.url);
            return of(router.createUrlTree(['/login']));
        })
    );
};
